import { Component, EventEmitter, Output } from "@angular/core"

@Component({
    selector: "app-media-gallery-buttons",
    templateUrl: "./media-gallery-buttons.component.html",
    styleUrls: ["./media-gallery-buttons.component.scss"],
    standalone: false,
})
export class MediaGalleryButtonsComponent {
    @Output() leftAction: EventEmitter<boolean> = new EventEmitter<boolean>()
    @Output() rightAction: EventEmitter<boolean> = new EventEmitter<boolean>()

    constructor() {}

    previewLeft() {
        this.leftAction.emit(true)
    }

    previewRight() {
        this.rightAction.emit(true)
    }
}
